import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AddHomeSlider from "./add";
import ListHomeSlider from "./list";

const Main = ({ match }) => (
  <Switch>
    <Route path={`${match.url}/add`} component={AddHomeSlider} />
    <Route path={`${match.url}/edit/:id`} component={AddHomeSlider} />
    <Route path={`${match.url}/list`} component={ListHomeSlider} />
    <Route exact path={`${match.url}/`}>
      <Redirect to={`${match.url}/list`} />
    </Route>
  </Switch>
);

export default Main;
